export default __webpack_public_path__ + "static/media/image-xx99-mark-two.5dcebc1a.jpg";